export const getElcoConf = (confID) => {
   let conf = {}

   const confDefault = {
      navStickyZone: true,
      unifiedSearchEngine: {
         queryAdditionalParams: 'module=orange&bhv=occ',
         tracking: {
            category: 'top_search',
            action: 'search',
         },
      },
      tracking: {
         refz: {
            service: 'acc-digital',
         },
         Tealium: {
            idBased: true,
         },
      },
   }

   // HP =============================================
   conf['hp'] = {
      ...confDefault,
   }

   conf['hp-nl'] = {
      ...confDefault,
      footer: {
         pushBoutiqueZone: false, // masque la carte des boutiques du footer
      },
   }

   // TV & DIVERTISSEMENT ============================
   const divertDefault = {
      ...confDefault,
      unifiedSearchEngine: {
         ...confDefault.unifiedSearchEngine,
         cmplUrl: '//completion.ke.orange.fr/proxy/cmplsearchbox',
         queryAdditionalParams: 'module=chaine&bhv=tv&ap=-1',
      },
      tracking: {
         ...confDefault.tracking,
         Tealium: {
            profile: 'frshoporange',
            idBased: true,
         },
      },
   }

   conf['divert'] = {
      ...divertDefault,
      domainTitle: 'TV et divertissement',
   }

   conf['divert-mob'] = {
      ...divertDefault,
   }

   // BOUTIQUE =======================================
   const boutiqueDefault = {
      ...confDefault,
      unifiedSearchEngine: {
         ...confDefault.unifiedSearchEngine,
         queryAdditionalParams: 'module=chaine&bhv=boutique',
      },
      tracking: {
         ...confDefault.tracking,
         Tealium: {
            profile: 'frshoporange',
            idBased: true,
         },
      },
   }

   conf['boutique'] = {
      ...boutiqueDefault,
      domainTitle: 'Boutique',
   }

   conf['boutique-mob'] = {
      ...boutiqueDefault,
   }

   return conf[confID]
}
